import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    direcciones: [],
  },

  getters: {
    getDirecciones: (state) => state.direcciones,
  },

  mutations: {
    SET_DIRECCIONES(state, direcciones) {
      state.direcciones = direcciones;
    },
  },

  actions: {
    async fetchDirecciones({ commit }, idExpediente) {
      await axios
        .get(`PoliciaCuadrantes/C3/expediente/${idExpediente}/direcciones`)
        .then((response) => {
          commit('SET_DIRECCIONES', response.data.data);
        });
    },

    async saveDirecciones(_, direcciones) {
      await axios
        .post(`PoliciaCuadrantes/C3/expediente/${direcciones.fk_idExpediente}/direcciones`, direcciones);
    },

    async updateDirecciones(_, direcciones) {
      await axios
        .put(`PoliciaCuadrantes/C3/expediente/${direcciones.fk_idExpediente}/direcciones/${direcciones.fk_idDirecciones}`, direcciones);
    },
  },
};
